import { castArray, mapValues } from 'lodash';

export const patchOrderItemStaff = (items, orderItemIds, field, user) => {
  const ids = new Set(castArray(orderItemIds));
  return items?.map((item) =>
    ids.has(item?.id) ? { ...item, [field]: user } : item,
  );
};

export const patchNestedOrderItemStaff = (
  nestedData,
  dataKey,
  orderItemIds,
  field,
  user,
) => {
  const ids = new Set(castArray(orderItemIds));
  return mapValues(nestedData, (entry) =>
    entry?.[dataKey]?.data?.some((item) => ids.has(item?.id))
      ? {
          ...entry,
          [dataKey]: {
            ...entry?.[dataKey],
            data: patchOrderItemStaff(
              entry?.[dataKey]?.data,
              orderItemIds,
              field,
              user,
            ),
          },
        }
      : entry,
  );
};
